import React from "react";
import DoctorCard from "./DoctorCard";
import profile1 from "../Assets/profile-1.png";
import profile2 from "../Assets/profile-2.png";
import "../Styles/Doctors.css";

function Doctors() {
  return (
    <div className="doctor-section" id="doctors">
      <div className="dt-title-content">
        <h3 className="dt-title">
          <span>Meet Our Doctors</span>
        </h3>

        <p className="dt-description">
          Meet our exceptional team of specialist neurologists, dedicated to
          providing top-notch neurological care services at NeuroCare Clinic. Trust in their
          knowledge and experience to lead you towards a healthier brain and nervous system.
        </p>
      </div>

      <div className="dt-cards-content">
        <DoctorCard
          img={profile1}
          name="Dr. Bagadi Suneel Kumar"
          title="M.D,D.M.(NIMS) Neuro Physician For Headache, Seizures, Paralysis, Muscle & Nerve Disorders"
          stars="4.9"
          reviews="1800"
        />
        
        <DoctorCard
          img={profile2}
          name="Dr. Pydi Venu Madhavi"
          title="M.D(General Medicine), D.M. Endocrinology (osm) for diabetes, thyroids, pcos, growth & hormonal problem"
          stars="4.7"
          reviews="450"
        />
        
      </div>
    </div>
  );
}

export default Doctors;